import { render } from "./BottomSection.vue?vue&type=template&id=5eb54b4c&scoped=true"
import script from "./BottomSection.vue?vue&type=script&lang=js"
export * from "./BottomSection.vue?vue&type=script&lang=js"

import "./BottomSection.vue?vue&type=style&index=0&id=5eb54b4c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb54b4c"]])

export default __exports__